import type { FavoriteShort } from '@/modules/favorite/types/favorite.type.ts';

export class FavoriteFolderUtil {
  static nextParentId(folders: FavoriteShort[]) {
    return folders.reduce((max, folder) => Math.max(max, folder.parentId), 0) + 1;
  }
}
